import { render, staticRenderFns } from "./AuctionViewFees.vue?vue&type=template&id=3580e46a&"
import script from "./AuctionViewFees.vue?vue&type=script&lang=js&"
export * from "./AuctionViewFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports